import React from 'react';
import { FaDownload, FaEdit, FaTrash, FaCheck, FaClock } from 'react-icons/fa';

const PostsList = ({ posts, onEdit, onDelete, onDownload }) => {
    const getStatusBadge = (status) => {
        switch (status) {
            case 'approved':
                return (
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm flex items-center">
                        <FaCheck className="mr-1" />
                        Aprobado
                    </span>
                );
            case 'pending':
                return (
                    <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-sm flex items-center">
                        <FaClock className="mr-1" />
                        Pendiente
                    </span>
                );
            default:
                return null;
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
                <div key={post._id} className="bg-white rounded-lg shadow-md overflow-hidden">
                    {/* Imagen del Post */}
                    <div className="relative group">
                        <img
                            src={post.imageUrl}
                            alt={post.content}
                            className="w-full h-48 object-cover"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-4">
                            <button
                                onClick={() => onEdit(post)}
                                className="p-2 bg-white rounded-full text-blue-500 hover:text-blue-600 transition-colors"
                                title="Editar post"
                            >
                                <FaEdit />
                            </button>
                            <button
                                onClick={() => onDownload(post)}
                                className="p-2 bg-white rounded-full text-green-500 hover:text-green-600 transition-colors"
                                title="Descargar imagen"
                            >
                                <FaDownload />
                            </button>
                            <button
                                onClick={() => onDelete(post)}
                                className="p-2 bg-white rounded-full text-red-500 hover:text-red-600 transition-colors"
                                title="Eliminar post"
                            >
                                <FaTrash />
                            </button>
                        </div>
                    </div>

                    {/* Información del Post */}
                    <div className="p-4">
                        <div className="flex justify-between items-start mb-2">
                            <div className="text-sm text-gray-500">
                                {formatDate(post.createdAt)}
                            </div>
                            {getStatusBadge(post.status)}
                        </div>

                        <p className="text-gray-700 text-sm mb-2 line-clamp-3">
                            {post.content}
                        </p>

                        <div className="flex flex-wrap gap-2">
                            {post.platform && (
                                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                    {post.platform}
                                </span>
                            )}
                            {post.type && (
                                <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs">
                                    {post.type}
                                </span>
                            )}
                            {post.isAutoGenerated && (
                                <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs">
                                    Auto-generado
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PostsList; 